export const signatureTypes = ['SIGNATURE-RADIO', 'SIGNATURE-PROGRAM'];
